import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiService } from '@/services/api/service'
import { SyncSession } from '@/services/session/sync-session'
import { ApiClient } from './client'

const namespace: string = 'user'

/**
 * TODO: SPA側にも似た内容のUserServiceが存在しており、両者を統合し/src/services配下のAPIゲートウェイとしたい。
 * @see https://github.com/my-color/front/pull/5961#discussion_r763640704
 */
export class UserService extends ApiService {
  async registerProvisional(): Promise<Either<Error, void>> {
    try {
      return await SyncSession.onSynced(async () => {
        const response = await ApiClient.post('/api/register_provisional')

        log.debug({ service: `${namespace}/registerProvisional`, response })

        return new Right(undefined)
      })
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  /**
   * ログイン済みでアクセストークンが既に発行されている状態で、ユーザー情報を再取得する.
   *
   * 再取得された結果はレスポンスボディとして返らず、cookie更新の形で反映される.
   * @see https://github.com/my-color/front/issues/3544
   */
  async rehash(): Promise<Either<Error, null>> {
    try {
      const response = await ApiClient.post(`/api/user/current_user/rehash`)

      log.debug({ service: `${namespace}/rehash`, response })

      return new Right(null)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }
}
